import '@forest/native-diagnostics'

import { initializeNativeBridge, native } from '@forest/native-services'
import { overwriteGetLocale, type Locale } from './paraglide/runtime'
import { language } from './params'

overwriteGetLocale(() => language as Locale)

initializeNativeBridge({
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})

native.general.pageReady()
